import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "saveWhite",
  "use": "saveWhite-usage",
  "viewBox": "0 0 15 14",
  "content": "<symbol viewBox=\"0 0 15 14\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"saveWhite\">\n<path d=\"M14.4062 3.0625L11.7812 0.4375C11.5625 0.21875 11.0938 0 10.75 0H2.875C1.75 0 0.875 0.90625 0.875 2V12C0.875 13.125 1.75 14 2.875 14H12.875C13.9688 14 14.875 13.125 14.875 12V4.125C14.875 3.78125 14.6562 3.3125 14.4062 3.0625ZM7.875 12C6.75 12 5.875 11.125 5.875 10C5.875 8.90625 6.75 8 7.875 8C8.96875 8 9.875 8.90625 9.875 10C9.875 11.125 8.96875 12 7.875 12ZM10.875 5.5C10.875 5.78125 10.625 6 10.375 6H3.375C3.09375 6 2.875 5.78125 2.875 5.5V2.5C2.875 2.25 3.09375 2 3.375 2H10.375C10.625 2 10.875 2.25 10.875 2.5V5.5Z\" fill=\"white\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/sharedComponents/Icon/images/saveWhite.svg
// module id = RjdJ
// module chunks = 13